import { apiRequest } from './api'

export function listBills() {
  return apiRequest('/bills/list', {
    method: 'POST',
  })
}

export function createBill(payload) {
  return apiRequest('/bills/create', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function updateBill(payload) {
  return apiRequest('/bills/update', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function deleteBill(billId) {
  return apiRequest('/bills/delete', {
    method: 'POST',
    body: JSON.stringify({ billId }),
  })
}
